export default __webpack_public_path__ + "static/media/Front-Villa-Mr-Hassan-Joun.c782e1c7.jpg";